/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// NOTE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	note: {
		'& p': {
			color: `rgba(6, 43, 117, 0.5)`,
			extend: theme.typography.size.xxsmall
		}
	}
});